module.exports = __webpack_public_path__ + "static/media/Zubat_gaussian2.c6e4ff3a.png";